
/* injects from baggage-loader */

'use strict';

import AccountCodesComponent from './account.codes.component';

const AccountCodesPageModule = angular.module('account-codes-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('account.codes', {
        url: '/codes',
        component: 'accountCodes',
        protected: true,
        // Resolve promises into controller bindings, see component for bindings
        // resolve: { }
      });
  })
  .component('accountCodes', new AccountCodesComponent());

export default AccountCodesPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/account/codes/account.codes.module.js